<div class="top-banner-container">
  <div class="marquee">
    <div class="marquee-content">
      <ng-container *ngFor="let _ of items; let last = last">
        <span class="item">{{ text }}</span>
        <span *ngIf="!last">|</span>
      </ng-container>
    </div>
  </div>
</div>
